module.exports = __webpack_public_path__ + "img/pride.ef45f4ba.jpeg";